import React, { useEffect, useState } from "react";

import Button from "../../../component/common/Button";
import { ReactComponent as UserIcon } from "../../../assets/user.svg";
import { ReactComponent as BlackUserIcon } from "../../../assets/black user.svg";
import { ReactComponent as UsersIcon } from "../../../assets/users 02.svg";
import { ReactComponent as WhiteUsersIcon } from "../../../assets/white users.svg";
import { useFormContext } from "react-hook-form";
import ForCorporate from "../components/ForCorporate";
import ForIndividual from "../components/ForIndividual";
import { LeftArrowIcon } from "../../venues/venue details/Icons";

const SignUpIdentity = ({ setUserType, setStep }) => {
  const [personType, setPersonType] = useState("corporate");
  const [isProceed, setIsProceed] = useState(false);
  const { setValue } = useFormContext();

  const handleCorporate = () => {
    setUserType("corporate");
    setPersonType("corporate");
  };

  const handleIndividual = () => {
    setUserType("individual");
    setPersonType("individual");
  };

  const handleProceed = () => {
    setUserType(personType);
    setValue("userType", personType === "corporate" ? 1 : 2);
    setIsProceed(true);
  };

  return isProceed ? (
    personType === "corporate" ? (
      <ForCorporate />
    ) : (
      <ForIndividual />
    )
  ) : (
    <div className="flex  items-center justify-center min-h-screen bg-white p-[20px] sm:p-10">
      <div className="card w-[491px]">
        <div className="flex justify-start items-center ml-[-40px] ">
          <div
            className="cursor-pointer hover:text-blue-500"
            onClick={() => {
              setStep(0);
            }}
            title="Go back"
          >
            <LeftArrowIcon />
          </div>
          <h1 className="heading">Confirm your identity.</h1>
        </div>
        <p className="paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis morbi
          pulvinar venenatis non.
        </p>

        <p className="text-black">You are registering on our platform as</p>

        <div className="mt-5 mb-[20px] sm:mb-[60px] flex justify-between sm:flex-row flex-col gap-4 ">
          <Button
            content="Corporate person"
            classes={`${
              personType === "corporate"
                ? "bg-dark-blue text-white"
                : "bg-white text-black"
            } text-sm flex justify-center py-3 sm:w-[48%] w-full mb-0`}
            Icon={personType === "corporate" ? UserIcon : BlackUserIcon}
            onClick={handleCorporate}
          />
          <Button
            content="Individual person"
            classes={`${
              personType === "individual"
                ? "bg-dark-blue text-white"
                : "bg-white text-black"
            } text-sm  flex justify-center py-3 sm:w-[48%] w-full mb-0`}
            Icon={personType === "individual" ? WhiteUsersIcon : UsersIcon}
            iconClasess={`${personType === "individual" ? "" : ""}`}
            onClick={handleIndividual}
          />
        </div>

        <Button
          content="Proceed"
          classes="mt-[19px] bg-dark-blue hover:bg-blue-700 duration-300 my-0 justify-center"
          onClick={handleProceed}
        />
      </div>
    </div>
  );
};

export default SignUpIdentity;
